<template>
    <div>
        <h4 class="customer-info-title">
            {{ $t('label.customerHistory') }} ( {{ total }} {{ currency }} )
        </h4>
        <div class="customer-info-history" v-if="appointments.length">

            <div v-for="appointment in appointments" class="customer-info-history-item">
                <div class="customer-info-history-item-date">
                    {{ appointment.date | formatDate }}
                </div>
                <div v-for="task in appointment.tasks" class="customer-info-history-item-tasks">
                    <span class="customer-info-history-item-tasks-name">
                        {{ task.service ? task.service.name : $t('label.noDataAvailable') }} ({{ task.employee.name }})
                    </span>
                    <span class="customer-info-history-item-tasks-time">
                        {{ task.start | formatTime }} - {{ task.end | formatTime }}
                    </span>
                </div>
                <div v-for="material in appointment.materials" class="customer-info-history-item-materials">
                    <span class="customer-info-history-item-materials-name">
                        {{ material.name }}
                    </span>
                    <span class="customer-info-history-item-materials-quantity">
                        {{ material.quantity }} {{ material.unit }}
                    </span>
                </div>
                <div v-if="appointment.note" class="customer-info-history-item-note">
                    <div class="customer-info-history-item-note-cell">
                        <label>{{ $t('label.note') }}</label>
                        {{ appointment.note }}
                    </div>
                </div>
                <div class="customer-info-history-item-price">
                    <div class="customer-info-history-item-price-cell">
                        <label>{{ $t('label.price') }}</label>
                        <span>
                            {{ appointment.price }} {{ currency }}
                        </span>
                    </div>
                    <div class="customer-info-history-item-price-cell">
                        <label>{{ $t('label.total') }}</label>
                        <span>
                            {{ appointment.total }} {{ currency }}
                        </span>
                    </div>
                </div>
                <div class="customer-info-history-item-info">
                    <div class="customer-info-history-item-info-cell">
                        <label>{{ $t('label.created') }}</label>
                        {{ appointment.created_at | formatDateTime }}
                        <div v-if="appointment.created_by">
                            ({{ appointment.created_by.first_name }} {{ appointment.created_by.last_name }})
                        </div>
                    </div>
                    <div class="customer-info-history-item-info-cell">
                        <label>{{ $t('label.updated') }}</label>
                        {{ appointment.updated_at | formatDateTime }}
                        <div v-if="appointment.updated_by">
                            ({{ appointment.updated_by.first_name }} {{ appointment.updated_by.last_name }})
                        </div>
                    </div>
                </div>
            </div>
            <button v-if="showLoadMore" class="button-hollow" @click="loadMore">{{ $t('button.loadMore') }}</button>
        </div>
        <div v-else>
            <div class="no-data">
                {{ $t('label.noDataAvailable') }}
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import _ from 'lodash'
    import auth from '@/auth'
    import UserImage from '@/components/widgets/UserImageWidget'
    export default {
      components: {UserImage},
      name: 'CustomerAppointments',
      props: ['customer'],
      mounted () {
        this.load()
      },
      watch: {
        customer () {
          this.appointments = []
          this.page = 1
          this.limit = 5
          this.load()
        },
        appointments () {
          this.total = 0
          for (let i in this.appointments) {
            this.total = this.total + this.appointments[i].total
          }
        }
      },
      data () {
        return {
          currency: auth.getOrganization().currency.toUpperCase(),
          params: {
            page: 1,
            limit: 5
          },
          showLoadMore: false,
          appointments: [],
          total: 0
        }
      },
      methods: {
        load () {
          if (!this.customer.id) {
            return
          }
          this.$api.request({ method: 'get', url: '/v1/customers/' + this.customer.id + '/appointments', params: this.params }).then(response => {
            let self = this
            _.each(response.data.data, function (item) {
              if (self.appointments.indexOf(item) === -1) {
                Vue.set(self.appointments, self.appointments.length, item)
              }
            })
            self.showLoadMore = response.data.meta.last_page > self.params.page
          }).catch(error => {
            console.error(error)
            this.$events.fire('message-open', {
              type: 'error',
              message: this.$t('message.somethingWentWrong')
            })
          })
        },
        loadMore () {
          this.params.page++
          this.load()
        }
      }
    }
</script>


// WEBPACK FOOTER //
// src/components/pages/Organization/Customers/CustomerAppointments.vue